import { Leaf, Wheat, HandHeart } from "lucide-react";

const VALUES = [
  {
    icon: Wheat,
    title: "Masa delgada y crujiente",
    body: "Preparamos nuestra masa delgada y crujiente para lograr la textura perfecta en cada rebanada.",
  },
  {
    icon: Leaf,
    title: "Ingredientes frescos",
    body: "Producto local, queso fresco y vegetales seleccionados a mano.",
  },
  {
    icon: HandHeart,
    title: "Receta de familia",
    body: "Una receta heredada, perfeccionada en cada horno y cada noche.",
  },
];

export const About = () => {
  return (
    <section
      id="nosotros"
      data-testid="about-section"
      className="relative py-24 sm:py-32 lg:py-40"
    >
      <div className="max-w-3xl mx-auto px-6 sm:px-12 lg:px-24">
        <div>
          {/* Text */}
          <div>
            <div className="font-sans text-xs uppercase tracking-[0.3em] text-[#D96C42] mb-6">
              — Sobre nosotros
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] font-medium text-[#2B241D]">
              Una pizzería <em className="italic font-normal">de barrio</em>,
              con alma artesanal.
            </h2>
            <div className="mt-8 space-y-5 font-sans text-base sm:text-lg text-[#2B241D]/75 leading-relaxed font-light">
              <p>
                Pizzería Estilo Gali nació de una obsesión sana: hacer la pizza
                que nos gustaría comer todas las noches. Sin atajos, sin masas
                congeladas, sin prisa.
              </p>
              <p>
                Cada noche encendemos el horno y amasamos pensando en quienes
                vienen a vernos: vecinos, amigos, familias. Eso es lo que
                significa “Estilo Gali”.
              </p>
            </div>

            {/* Values */}
            <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6">
              {VALUES.map((v) => {
                const Icon = v.icon;
                return (
                  <div
                    key={v.title}
                    data-testid={`value-${v.title}`}
                    className="border-l-2 border-[#D96C42] pl-4"
                  >
                    <Icon
                      size={22}
                      strokeWidth={1.5}
                      className="text-[#D96C42] mb-3"
                    />
                    <h4 className="font-serif text-xl text-[#2B241D] mb-1.5">
                      {v.title}
                    </h4>
                    <p className="font-sans text-sm text-[#5C5146] leading-relaxed font-light">
                      {v.body}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
